export const pause = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.33333 12.6663H12V3.33301H9.33333M4 12.6663H6.66667V3.33301H4V12.6663Z" fill="white"/>
</svg>
`;
export const pauseOld = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.00195312" width="14.0001" height="13.9971" rx="1" fill="white"/>
</svg>

`;
